import styled from "../../../__compat__/styled-components/main.entry.mjs.mjs";
import { StyledInput, fadeDuration, } from "../GenericOption/GenericOption.styles.mjs.mjs";
export const StyledRadioButton = styled(StyledInput).attrs({ type: 'radio' }).withConfig({ displayName: "auir-611444a-StyledRadioButton", componentId: "auir-611444a-1mnhj7d" }) `
  border-radius: 50%;
  position: relative;

  /* Dot */
  &::before {
    position: absolute;
    display: block;
    width: 8px;
    height: 8px;

    background-color: var(
      ${(props) => props.theme.colors.interaction.tertiary.default}
    );
    border-radius: 50%;
    transform: scale(1);
    transform-origin: 50%;

    transition: ${fadeDuration} var(${(props) => props.theme.easing});
    transition-property: transform background-color;

    content: '';
  }

  /* Dot checked */
  &:checked::before {
    background-color: var(
      ${(props) => props.theme.colors.interaction.secondary.filled}
    );
    transform: scale(1.5);
  }

  /* Dot readonly */
  &[readonly]::before {
    background-color: var(
      ${(props) => props.theme.colors.interaction.tertiary.default}
    );
  }

  /* Dot readonly */
  &[readonly]:checked::before {
    background-color: var(
      ${(props) => props.theme.colors.interaction.secondary.filled}
    );
  }

  /* Dot invalid */
  &:invalid::before {
    background-color: ${(props) => props.invalid &&
    `var(${props.theme.colors.interaction.tertiary.default})`};
  }

  /* Dot disabled */
  &:disabled::before {
    background-color: var(
      ${(props) => props.theme.colors.interaction.tertiary.disabled}
    );
  }

  /* Dot disabled checked */
  &:disabled:checked::before {
    background-color: var(
      ${(props) => props.theme.colors.interaction.tertiary.disabled}
    );
  }

  /* Dot invalid checked */
  &:invalid:checked::before {
    background-color: ${(props) => props.invalid && `var(${props.theme.colors.ui.error})`};
  }

  /* Dot hover */
  &:enabled:not([readonly]):not(:checked):hover::before {
    background-color: var(
      ${(props) => props.theme.colors.interaction.tertiary.hover}
    );
    transform: scale(1.25);
  }

  /* Dot checked:hover */
  &:enabled:not([readonly]):checked:hover::before {
    transform: scale(1.25);
  }

  /* Dot checked:hover */
  &:enabled:not([readonly]):checked:valid:hover::before {
    background-color: var(
      ${(props) => props.theme.colors.interaction.secondary.filled}
    );
  }
`;
//# sourceMappingURL=RadioButton.styles.mjs.mjs.map